import { ISecret, ISecretResponse } from '@mode/notebooks/contract';

export function toSecretKeys(resource: ISecretResponse): ISecret[] {
  return resource._embedded.stored_credentials.map((secret: ISecret) => ({
    token: secret.token,
    key: secret.key,
    secret_type: secret.secret_type,
    secret_source_id: secret.secret_source_id,
  }));
}
